class PlugHomepageHero extends HTMLElement {
    constructor() {
        super();
        window.PLUG.utils.bindThisToAllMethods(this);
    }

    connectedCallback() {
        this.activeIndex = 0;
        this.slides = Array.from(this.querySelectorAll(".plug-hp-hero__slide"));
        if (this.slides.length < 2) {
            return;
        }
        this.navButtons = Array.from(this.querySelectorAll(".plug-hp-hero-nav__button"));
        this.buttonSeparators = Array.from(this.querySelectorAll(".plug-hp-hero-nav__sep-inner"));
        this.autoplayEnabled = (this.dataset.autoplayEnabled === "true");
        this.timerDurationMs = Number(this.dataset.autoplayInterval) * 1000;
        this.autoplayRequest = undefined;

        this.startAutoplay();

        this.navButtons.forEach((button, index) => {
            button.addEventListener("click", () => {
                this.setActiveSlide(index);
            });
        })
    }

    resetAutoplay() {
        if (!this.autoplayEnabled) {
            return;
        }
        if (this.autoplayRequest) {
            cancelAnimationFrame(this.autoplayRequest);
        }
        this.navButtons.forEach((button, index) => {
            const buttonInner = button.querySelector(".plug-hp-hero-nav__button-inner");
            buttonInner.style.background = "transparent";
            let buttonSepInner;
            if (index < this.buttonSeparators.length) {
                buttonSepInner = this.buttonSeparators[index];
                buttonSepInner.style.width = "";
            }
        });
    }

    startAutoplay() {
        if (!this.autoplayEnabled) {
            return;
        }
        const button = this.navButtons[this.activeIndex];
        const buttonInner = button.querySelector(".plug-hp-hero-nav__button-inner");
        const hasButtonSep = this.activeIndex < this.buttonSeparators.length;
        let buttonSepInner;
        if (hasButtonSep) {
            buttonSepInner = this.buttonSeparators[this.activeIndex];
        }
        const timerDurationMs = this.timerDurationMs;
        let t0;

        const step = (t) => {
            if (t0 === undefined) {
                t0 = t;
            }

            const elapsed = t - t0;
            const percentComplete = elapsed / timerDurationMs;
            const degrees = Math.min(360 * percentComplete, 360);
            if (hasButtonSep) {
                const sepLength = Math.min(100 * percentComplete, 100);
                buttonSepInner.style.width = `${sepLength}%`;
            }

            buttonInner.style.background = `conic-gradient(currentColor ${degrees}deg, transparent ${degrees}deg ${360 - degrees}deg)`;

            if (degrees !== 360) {
                this.autoplayRequest = requestAnimationFrame(step);
            } else {
                buttonInner.style.background = "";
                this.setActiveSlide(
                    this.activeIndex === this.slides.length - 1
                    ? 0
                    : this.activeIndex + 1
                );
            }
        };

        this.autoplayRequest = window.requestAnimationFrame(step);
    }

    setActiveSlide(slideIndex) {
        if (this.activeIndex === slideIndex) {
            return;
        }
        const lastActiveIndex = this.activeIndex;
        this.activeIndex = slideIndex;
        this.hideSlide(lastActiveIndex);
        this.showSlide(this.activeIndex);
        this.resetAutoplay();
        this.startAutoplay();
    }

    showSlide(slideIndex) {
        const slide = this.slides[slideIndex];
        const navButton = this.navButtons[slideIndex];
        const mobileReviewSample = this.querySelector(`.plug-hp-hero__sample-review-mobile[data-index="${slideIndex}"]`);
        const button = slide.querySelector(".button");
        if (button) {
            button.classList.remove("plug-btn-ready");
        }
        navButton.classList.add("is-active");
        slide.classList.remove("is-hidden");
        if (mobileReviewSample) {
            mobileReviewSample.classList.remove("is-hidden");
        }
        PLUG.utils.afterNextFrame(() => {
            slide.classList.add("is-visible");
            if (button) {
                setTimeout(() => {
                    button.classList.add("plug-btn-ready");
                }, 600);
            }
        });
    }

    hideSlide(slideIndex) {
        const slide = this.slides[slideIndex];
        const navButton = this.navButtons[slideIndex];
        const mobileReviewSample = this.querySelector(`.plug-hp-hero__sample-review-mobile[data-index="${slideIndex}"]`);
        slide.classList.remove("is-visible");
        slide.classList.add("is-hidden");
        navButton.classList.remove("is-active");
        if (mobileReviewSample) {
            mobileReviewSample.classList.add("is-hidden");
        }
    }
}


window.customElements.define("plug-homepage-hero", PlugHomepageHero);